import { createSelector } from 'reselect'
import { selectIsBillingDataLoaded } from './selectIsBillingDataLoaded'
import { selectIsInboxActive } from './selectIsInboxActive'
import { selectIsAccountClosed } from './selectIsAccountClosed'
import { selectIsAccountExpired } from './selectIsAccountExpired'

export const selectIsBillingAccountActive = createSelector(
  selectIsAccountExpired,
  selectIsAccountClosed,
  selectIsInboxActive,
  selectIsBillingDataLoaded,
  (isAccountExpired, isAccountClosed, isInboxActive, isBillingLoaded) => {
    if (!isBillingLoaded) return true
    if (isAccountExpired || isAccountClosed) return false
    if (!isInboxActive) return false
    return true
  }
)
